//SLVI-1334-INICIO
import React, { useState, useEffect, useRef, useMemo } from 'react'; //SLVI-1334-FIX-03-INICIO/FIM
import { Redirect, useLocation } from 'react-router-dom';
import axios from 'axios';
import { getCodigoOferta } from '../../util/codigoOferta'; // ANNVI-1 - INICIO/FIM // ANNVI-33 - INICIO/FIM
//SLVI-827-FIX-IDOR INICIO
import dataConverter from './dataConverter';
import urlParamsHelper from './urlParamsHelper';
//SLVI-827-FIX-IDOR FIM
import useSessionGuard from '../../hooks/useSessionGuard';
import Header from '../Header';

export default function Validation(){
    // const [valido, setValido] = useState(false);
    let valido = false;
    const [susep, setSusep] = useState('');
    const [validSession, setValidSession] = useState(true);
    const [erroIntegracao, setErroIntegracao] = useState('Erro de sistema');
    //SLVI-1334-FIX-03-INICIO
    // Ref para evitar múltiplas chamadas de autenticação concorrentes (race condition)
    const authInProgressRef = useRef(false);
    //SLVI-1334-FIX-03-FIM
    const location = useLocation();
    useSessionGuard();
    const REACT_APP_PORTAL_URL = process.env.REACT_APP_PORTAL_URL;
    //SLVI-Ajuste Broken Acess GDO-RPA INICIO
    const REACT_APP_PORTAL_URL2 = process.env.REACT_APP_PORTAL_URL2;
    const REACT_APP_PORTAL_URL3 = process.env.REACT_APP_PORTAL_URL3;

    //SLVI-1334-FIX-06-INICIO
    const REACT_APP_USE_COLWS_AUTH = process.env.REACT_APP_USE_COLWS_AUTH;
   

    //console.log('Ultima url',document.referrer);
    //console.log('REACT_APP_PORTAL_URL ',REACT_APP_PORTAL_URL);
	//console.log('REACT_APP_PORTAL_URL2 ',REACT_APP_PORTAL_URL2);
    //console.log('REACT_APP_PORTAL_URL3 ',REACT_APP_PORTAL_URL3);
    //console.log('REACT_APP_USE_COLWS_AUTH',REACT_APP_USE_COLWS_AUTH);
    //SLVI-Ajuste Broken Acess GDO-RPA FIM

   

    //SLVI-827-FIX-IDOR INICIO
    let urlOrigem = localStorage.getItem("urlOrigem");
    const loginValido = localStorage.getItem("loginValido");

    // LOG PONTO 1 — Estado do localStorage no início do render
    console.log('%c[VALIDATION P1] Início do render', 'color: blue; font-weight: bold');
    //console.log('[VALIDATION P1] urlOrigem no localStorage:', urlOrigem ? 'EXISTE' : 'VAZIO');
    //console.log('[VALIDATION P1] loginValido no localStorage:', loginValido);
    //console.log('[VALIDATION P1] expires no localStorage:', localStorage.getItem('expires'));
    //console.log('[VALIDATION P1] colwsLoginValido no localStorage:', localStorage.getItem('colwsLoginValido'));
    //console.log('[VALIDATION P1] window.location.search (query string atual):', window.location.search);
    //console.log('[VALIDATION P1] document.referrer:', document.referrer);

    //SLVI-1334-FIX-06-FIM
    
    //SLVI-1334-FIX-05 INICIO
    // Valida se deve salvar nova URL
    if (window.location.search && !urlOrigem) {
        // Caso 1: Não existe urlOrigem salva - primeira vez
        // Não salva se a URL atual é uma URL de erro (redirecionamento interno)
        const searchParams = new URLSearchParams(window.location.search);
        if (!searchParams.get('erro')) {
            const urlEncoded = dataConverter.toBase64(window.location.search);
            localStorage.setItem("urlOrigem", urlEncoded);
            urlOrigem = urlEncoded;
        }
    } else if (window.location.search && urlOrigem && loginValido === "false") {
        const urlAtualEncoded = dataConverter.toBase64(window.location.search);
        const urlOrigemDecoded = dataConverter.fromBase64(urlOrigem);
        const searchParams = new URLSearchParams(window.location.search);

        if (window.location.search !== urlOrigemDecoded && !searchParams.get('erro')) {
            localStorage.setItem("urlOrigem", urlAtualEncoded);
            urlOrigem = urlAtualEncoded;
        }
        //SLVI-1334-FIX-05 FIM
    } else if (window.location.search && urlOrigem && loginValido === "true") {
        const urlOrigemDecoded = dataConverter.fromBase64(urlOrigem);
        
        if (window.location.search !== urlOrigemDecoded) {
            console.log('Login já válido - mantendo URL original');
        }
    }

    const info = dataConverter.fromBase64(urlOrigem || '');
    //SLVI-827-FIX-IDOR FIM
    if (window.location.search) {
        window.history.replaceState({}, document.title, window.location.pathname);
    }

    //SLVI-1334-FIX-03-INICIO
    const urlParams = useMemo(() => new URLSearchParams(info), [info]);
    //SLVI-1334-FIX-03-FIM

    useEffect(e=>{
        //SLVI-1334-FIX-05 INICIO
        let isMounted = true;

        const setStorage = () => {
            let data = new Date();
            data.setHours(data.getHours() + 1);
            localStorage.setItem("expires", data);
        }

        const getStorage = () => {
            if(localStorage.getItem('expires')){
                if(new Date(localStorage.getItem('expires')) < new Date()){
                    //SLVI-827-FIX-IDOR INICIO
                    //SLVI-1334-FIX-03-INICIO
                    const savedUrlOrigem = localStorage.getItem('urlOrigem');
                    //SLVI-1334-FIX-03-FIM
                    localStorage.clear();
                    //SLVI-1334-FIX-03-INICIO
                    if (savedUrlOrigem) {
                        localStorage.setItem('urlOrigem', savedUrlOrigem);
                        console.log('%c[VALIDATION P3] urlOrigem restaurada após limpar storage expirado', 'color: orange; font-weight: bold');
                    }
                    //SLVI-1334-FIX-03-FIM
                    console.log('%c[VALIDATION P3] Sessão EXPIRADA — localStorage limpo', 'color: orange; font-weight: bold');
                    return false; // Retorna false quando expirado
                }
                console.log('%c[VALIDATION P3] Sessão ainda VÁLIDA no storage (expires ok)', 'color: green; font-weight: bold');
                return true;
                 //SLVI-827-FIX-IDOR FIM
            }
            console.log('%c[VALIDATION P3] Sem expires no storage — primeira autenticação necessária', 'color: orange; font-weight: bold');
            return false;
        }

        // const validate = async () => {  
        //     if(
        //         urlParams.get('webusrcod') !== null &&
        //         urlParams.get('sesnum') !== null &&
        //         urlParams.get('corsus') !== null
        //     ){
        //         await axios.post('/auth', {
        //             codigoUsuario : urlParams.get('webusrcod'),
        //             numeroSessao  : urlParams.get('sesnum'),
        //             susepCorretor : urlParams.get('corsus')
        //         }).then(e=>{
        //             if(e.status === 200){
        //                 valido = true;
        //                 return true;
        //             }else{
        //                 setErroIntegracao(e.response.data.result.userErrorDescription || 'A sessão do usuário é inválida');
        //                 return false;
        //             }
        //         }).catch(e=>{
        //             setErroIntegracao(e.response.data.result.userErrorDescription || 'A sessão do usuário é inválida');
        //             return false;
        //         });
        //     }else{
        //         setErroIntegracao('Parâmetros de entrada necessários');
        //         return false;
        //     }
        // }

        const validate = async () => {
            //SLVI-827-FIX-IDOR INICIO
            const hasStoredUrlParams = urlParamsHelper.getParam('webusrcod') && 
                                       urlParamsHelper.getParam('sesnum') && 
                                       urlParamsHelper.getParam('corsus');

            // LOG PONTO 4 — Verificação dos parâmetros e referrer
            //console.log('%c[VALIDATION P4] Verificando parâmetros e referrer', 'color: blue; font-weight: bold');
            //console.log('[VALIDATION P4] webusrcod:', urlParamsHelper.getParam('webusrcod') || '(vazio)');
            //console.log('[VALIDATION P4] sesnum:', urlParamsHelper.getParam('sesnum') || '(vazio)');
            //console.log('[VALIDATION P4] corsus:', urlParamsHelper.getParam('corsus') || '(vazio)');
            //console.log('[VALIDATION P4] cpf:', urlParamsHelper.getParam('cpf') || '(vazio)');
            //console.log('[VALIDATION P4] hasStoredUrlParams:', hasStoredUrlParams ? 'SIM ✅' : 'NÃO ❌');
            //console.log('[VALIDATION P4] referrer:', document.referrer || '(vazio)');
            //console.log('[VALIDATION P4] PORTAL_URL esperadas:', REACT_APP_PORTAL_URL, '|', REACT_APP_PORTAL_URL2, '|', REACT_APP_PORTAL_URL3);
            //const referrerValido = document.referrer.startsWith(REACT_APP_PORTAL_URL) || document.referrer.startsWith(REACT_APP_PORTAL_URL2) || document.referrer.startsWith(REACT_APP_PORTAL_URL3);
            //console.log('[VALIDATION P4] referrer é válido:', referrerValido ? 'SIM ✅' : 'NÃO ❌');
                    
            // Valida se o acesso veio do portal do corretor
            //SLVI-Ajuste Broken Acess GDO-RPA INICIO
            if (!document.referrer.startsWith(REACT_APP_PORTAL_URL) && !document.referrer.startsWith(REACT_APP_PORTAL_URL2) && !document.referrer.startsWith(REACT_APP_PORTAL_URL3)) {
                //if (2 < 1) {
                console.log('%c[VALIDATION P4] BLOQUEADO — referrer inválido', 'color: red; font-weight: bold');
                setErroIntegracao('Parâmetros de entrada necessários. Acesse o portal do corretor para acessar novamente.');
                return false;
            }else{
                if(hasStoredUrlParams){  //SLVI-827-FIX-IDOR FIM
                    console.log('%c[VALIDATION P4] OK — referrer e parâmetros válidos', 'color: green; font-weight: bold');
                    valido = true;
                    return true;
                }else{
                    // Só mostra erro se realmente tentou acessar com params incompletos
                    if (window.location.search) {
                        console.log('%c[VALIDATION P4] BLOQUEADO — parâmetros incompletos na URL', 'color: red; font-weight: bold');
                        setErroIntegracao('Parâmetros de entrada necessários. Acesse o portal do corretor para acessar novamente.');
                        return false;
                    }
                    console.log('%c[VALIDATION P4] Sem params e sem query string — aguardando', 'color: orange; font-weight: bold');
                    return false;
                }
            }
            //SLVI-827-FIX-IDOR FIM
        }

        const valid = async () => {
            // ANNVI-1 - INICIO
            if(urlParams.get('erro')){
                console.log('%c[VALIDATION P5] Param "erro" detectado na URL — bloqueando sessão', 'color: red; font-weight: bold');
                setValidSession(false);
                localStorage.setItem("loginValido", "false"); //SLVI-827-FIX-IDOR INICIO/FIM
                return;
            }
            // ANNVI-1 - FIM
            //SLVI-1334-FIX-03-INICIO
            // Evita chamadas concorrentes: se já existe uma autenticação em andamento, ignora
            if (authInProgressRef.current) {
                console.log('%c[VALIDATION P5] Auth já em andamento — ignorando chamada duplicada', 'color: orange; font-weight: bold');
                return;
            }
            authInProgressRef.current = true;
            console.log('%c[VALIDATION P5] Iniciando fluxo de autenticação', 'color: blue; font-weight: bold');
            //SLVI-1334-FIX-03-FIM
            if(!getStorage()){
                console.log('%c[VALIDATION P5] Storage inválido/expirado — executando validate()', 'color: blue; font-weight: bold');
                await validate();
                console.log('[VALIDATION P5] Resultado do validate() — valido:', valido ? 'true ✅' : 'false ❌');
                if(valido){
                    //SLVI-1334-FIX-05-INICIO
                    if (!isMounted) {
                        console.log('%c[VALIDATION P6] Componente desmontado — cancelando autenticação', 'color: orange; font-weight: bold');
                        authInProgressRef.current = false;
                        return;
                    }

                    if (REACT_APP_USE_COLWS_AUTH == 'false') {
                        console.log('%c[VALIDATION P6] REACT_APP_USE_COLWS_AUTH=false — validando via hasRequiredParams', 'color: blue; font-weight: bold');
                        if (urlParamsHelper.hasRequiredParams()) {
                            console.log('%c[VALIDATION P6] hasRequiredParams=true — sessão liberada', 'color: green; font-weight: bold');
                            setStorage();
                            setValidSession(true);
                            localStorage.setItem("loginValido", "true");
                        } else {
                            console.error('%c[VALIDATION P6] hasRequiredParams=false — sessão inválida', 'color: red; font-weight: bold');
                            setErroIntegracao('Sessão inválida. Faça login novamente.');
                            setValidSession(false);
                            localStorage.setItem("loginValido", "false");
                        }
                        authInProgressRef.current = false;
                    } else {
                    const cpf    = urlParamsHelper.getParam('cpf');
                    const corsus = urlParamsHelper.getParam('corsus');
                    const userName = `${cpf}_${corsus}`;

                    console.log('%c[VALIDATION P6] Chamando /auth/colws/sicredi', 'color: blue; font-weight: bold');
                    console.log('[VALIDATION P6] userName montado:', userName);

                    try {
                        const response = await axios.post('/auth/colws/sicredi', { userName });
                        const { resultCode, sessionToken } = response.data || {};

                        console.log('%c[VALIDATION P6] Resposta do Sicredi recebida', 'color: blue; font-weight: bold');
                        console.log('[VALIDATION P6] resultCode:', resultCode);
                        console.log('[VALIDATION P6] sessionToken recebido:', sessionToken ? 'SIM ✅' : 'NÃO ❌');

                        if (resultCode === 'LOGIN_SUCCESS') {
                            console.log('%c[VALIDATION P6] LOGIN_SUCCESS — salvando cookie e liberando acesso', 'color: green; font-weight: bold');
                            document.cookie = `sessionToken=${sessionToken}; path=/; SameSite=Strict`;
                            localStorage.setItem('colwsLoginValido', 'true');
                            setStorage();
                            setValidSession(true);
                            localStorage.setItem("loginValido", "true");
                        } else {
                            console.error('%c[VALIDATION P6] LOGIN NEGADO — resultCode inesperado', 'color: red; font-weight: bold', resultCode);
                            console.error('[VALIDATION P6] userName usado:', userName);
                            console.error('[VALIDATION P6] Resposta completa:', response.data);
                            setErroIntegracao('Não foi possível autenticar. Acesse o portal do corretor novamente.');
                            setValidSession(false);
                            localStorage.setItem("loginValido", "false");
                        }
                    } catch (error) {
                        console.error('%c[VALIDATION P6] ERRO na chamada ao Sicredi', 'color: red; font-weight: bold');
                        console.error('[VALIDATION P6] userName usado:', userName);
                        console.error('[VALIDATION P6] HTTP status:', error?.response?.status);
                        console.error('[VALIDATION P6] Resposta do servidor:', error?.response?.data);
                        console.error('[VALIDATION P6] Erro completo:', error.message);
                        setErroIntegracao('Erro de autenticação. Tente novamente mais tarde.');
                        setValidSession(false);
                        localStorage.setItem("loginValido", "false");
                    } finally {
                        authInProgressRef.current = false;
                        }
                    }
                    //SLVI-1334-FIX-05-FIM
                }else{
                    console.log('%c[VALIDATION P5] validate() retornou false — sessão inválida', 'color: red; font-weight: bold');
                    authInProgressRef.current = false; //SLVI-1334-FIX-03-INICIO/FIM
                    setValidSession(false);
                    localStorage.setItem("loginValido", "false"); //SLVI-827-FIX-IDOR INICIO/FIM
                }
            }else{
/*                 //PLV-4782 - INICIO
                if(urlParams.get('codigoOferta')) 
                    localStorage.setItem("codigoOferta", getCodigoOferta(urlParams.get('codigoOferta') || '')); // ANNVI-1 - INICIO/FIM // ANNVI-33 - INICIO/FIM
                 //PLV-4782 - FIM
                //PLV-5079 - INICIO
                if(urlParams.get('corsus')) 
                    localStorage.setItem("susepCorretor", urlParams.get('corsus') || ''); 
                //PLV-5079 - FIM */
                console.log('%c[VALIDATION P5] Storage válido — sessão reutilizada sem nova autenticação', 'color: green; font-weight: bold');
                authInProgressRef.current = false; //SLVI-1334-FIX-03-INICIO/FIM
                setValidSession(true);
                localStorage.setItem("loginValido", "true"); //SLVI-827-FIX-IDOR INICIO/FIM
            }
        }

        const getValid = async()=>{
            await valid();
            
            //SLVI-827-FIX-IDOR INICIO
            // Após validação, se login for inválido, remove urlOrigem
            if(localStorage.getItem("loginValido") === "false"){
                console.log('Login inválido detectado - removendo urlOrigem');
                localStorage.removeItem("urlOrigem");
            }
            //SLVI-827-FIX-IDOR FIM
        }
        
        setSusep(urlParamsHelper.getParam('corsus') || urlParams.get('corsus') || ''); //SLVI-827-FIX-IDOR INICIO/FIM
        getValid();     
        console.log('Validação concluída', { valido, validSession });
        return () => { isMounted = false; };
        //SLVI-1334-FIX-05-FIM
    //SLVI-1334-FIX-03-INICIO
    }, [urlParams]);
    //SLVI-1334-FIX-03-FIM

    return validSession && location.pathname !== '/error' ? 
            //SLVI-1334-INICIO
            <Header susep={susep} />
            //SLVI-1334-FIM
            : !validSession 
                ? <Redirect to={{
                    pathname: "/error",
                    search: "?erro=" + erroIntegracao,
                }} />
                : null; 
}
//SLVI-1334-FIM